import { Text } from "@chakra-ui/react";
import { ContentDivider } from "./ContentDivider";
import { useMobileBreakpoint } from "../../../utils/useBreakpoints";

export interface LegalHeaderProps {
  title: string;
  lastUpdated?: string;
}

export function LegalHeader({
  title,
  lastUpdated = "May 20, 2025",
}: LegalHeaderProps) {
  const isMobile = useMobileBreakpoint();

  return (
    <>
      <Text
        variant="legalTitle"
        pb="16px"
        pt={!isMobile ? "20px" : undefined}
      >
        {title}
      </Text>
      <Text variant="lastUpdate" pb="24px">
        Last Updated: {lastUpdated}
      </Text>
      <ContentDivider />
    </>
  );
}
